import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lightbox", "videoLightbox", "video"]

  openLightbox(event) {
    const targetId = event.params.target
    const lightbox = document.getElementById(targetId)
    if (lightbox) lightbox.classList.add("is-open")
  }

  closeLightbox(event) {
    event.stopPropagation()
    event.target.closest(".video-lightbox").classList.remove("is-open")
  }

  closeLightboxBackground(event) {
    if (event.target === event.currentTarget) {
      event.currentTarget.classList.remove("is-open")
    }
  }

  openVideoLightbox(event) {
    const url = event.currentTarget.dataset.videoUrl
    if (!url) return

    this.videoTarget.src = url
    this.videoLightboxTarget.classList.add("is-open")
    this.videoTarget.play()
  }

  closeVideoLightbox(event) {
    event.stopPropagation()
    this.#closeVideo()
  }

  closeVideoLightboxBackground(event) {
    if (event.target === event.currentTarget) this.#closeVideo()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  #closeVideo() {
    this.videoTarget.pause()
    this.videoTarget.src = ""
    this.videoLightboxTarget.classList.remove("is-open")
  }
}
